import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Shell } from "@/components/Shell";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

export default function Login() {
  const { signIn } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const { data } = await api.post("/auth/login", form);
      signIn(data);
      nav(data.user.role === "admin" ? "/admin" : "/play");
    } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <Shell hideNav>
      <div className="fade-up">
        <p className="eyebrow">Welcome back</p>
        <h1 className="mt-2 font-display text-3xl font-extrabold tracking-tight">Log in</h1>
        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="login-form">
          <label className="block">
            <span className="eyebrow mb-2 block">Email</span>
            <input className="field" type="email" value={form.email} onChange={set("email")} placeholder="you@example.com" required autoComplete="email" data-testid="login-email-input" />
          </label>
          <label className="block">
            <span className="eyebrow mb-2 block">Password</span>
            <input className="field" type="password" value={form.password} onChange={set("password")} placeholder="Your password" required autoComplete="current-password" data-testid="login-password-input" />
          </label>
          {error && <p className="rounded-xl border border-rose-500/40 bg-rose-500/10 px-4 py-3 text-sm text-rose-300" data-testid="login-error">{error}</p>}
          <button className="btn-primary w-full" disabled={busy} data-testid="login-submit-button">{busy ? "Logging in…" : "Log in"}</button>
          <p className="text-center text-sm"><Link to="/forgot-password" className="text-slate-400 underline-offset-4 hover:text-white hover:underline" data-testid="login-forgot-link">Forgot password?</Link></p>
        </form>
        <p className="mt-6 text-center text-sm text-slate-400">New here? <Link to="/register" className="font-semibold text-white underline-offset-4 hover:underline" data-testid="login-register-link">Create an account</Link></p>
      </div>
    </Shell>
  );
}
